import Vue from 'vue'
import App from './pages/App'
import Login from './pages/Login'
import Profile from './pages/Profile'
import Admin from './pages/Admin'
import vuetify from './plugins/vuetify'
import axios from './plugins/axios'

Vue.config.productionTip = false

const routes = {
  '/': App,
  '/login': Login,
  '/profile': Profile,
  '/admin': Admin
}

new Vue({
  vuetify,
  axios,
  created() {
    window.addEventListener('hashchange', () => {
      this.currentRoute = window.location.hash.slice(1)
      console.info(`routing to ${this.currentRoute}`)
    })
  },
  data: {
    currentRoute: window.location.hash.slice(1) || '/'
  },
  computed: {
    ViewComponent () {
      return routes[this.currentRoute] || App
    }
  },
  render (h) { return h(this.ViewComponent) }
}).$mount('#app')

